import { render, staticRenderFns } from "./SoftwareCategoryReviewsSlider.vue?vue&type=template&id=eef675bc"
import script from "./SoftwareCategoryReviewsSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./SoftwareCategoryReviewsSlider.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIcon: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/components/ui/UiIcon.vue').default})
